import { FencesMainPageType } from 'landings/fences/fences-types';
import { FencesOtherTypesStructure } from './fences-other-types-types';
import { FENCES_CDN_PATH } from '../../fences-constants';

const PROFNASTIL_OTHER_TYPE = {
  key: 'zabory-iz-profnastila',
  alt: 'Забор из профнастила',
  imgSrc: `${FENCES_CDN_PATH}/other-types/profnastil.jpg/profnastil.jpg`,
  title: 'Заборы из\u00A0профнастила',
  link: {
    href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/zabory-iz-profnastila/',
    title: 'Заборы из профнастила на заказ',
  },
};

const SHTAKETNIK_OTHER_TYPE = {
  key: 'metallicheskiy-shtaketnik',
  alt: 'Металлический штакетник',
  imgSrc: `${FENCES_CDN_PATH}/other-types/shtaketnik.jpg/shtaketnik.jpg`,
  title: 'Металлический штакетник',
  link: {
    href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/metallicheskiy-shtaketnik/',
    title: 'Металлический штакетник на заказ',
  },
};

const MODULNYE_OGRAZHDENIYA_OTHER_TYPE = {
  key: 'modulnye-ograzhdeniya',
  alt: 'Модульные ограждения',
  imgSrc: `${FENCES_CDN_PATH}/other-types/modulnye-ograzhdeniya.jpg/modulnye-ograzhdeniya-1.jpg`,
  title: 'Модульные ограждения',
  link: {
    href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/modulnye-ograzhdeniya/',
    title: 'Модульные ограждения на заказ',
  },
};

const PANELNYE_OGRAZHDENIYA_OTHER_TYPE = {
  key: 'panelnye-ograzhdeniya',
  alt: 'Панельные ограждения',
  imgSrc: `${FENCES_CDN_PATH}/other-types/panelnye-ograzhdeniya.jpg/panelnye-ograzhdeniya.jpg`,
  title: 'Панельные ограждения',
  link: {
    href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/panelnye-ograzhdeniya/',
    title: 'Панельные ограждения на заказ',
  },
};

const ZHALYUZI_OTHER_TYPE = {
  key: 'zabory-zhalyuzi',
  alt: 'Заборы-жалюзи',
  imgSrc: `${FENCES_CDN_PATH}/other-types/zhalyuzi.jpg/zhalyuzi.jpg`,
  title: 'Заборы-жалюзи',
  link: {
    href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/zabory-zhalyuzi/',
    title: 'Заборы-жалюзи на заказ',
  },
};

export const FENCES_OTHER_TYPES_LIST_MAP: Record<FencesMainPageType, FencesOtherTypesStructure[]> = {
  withoutPanelModulZhalyuzi: [PROFNASTIL_OTHER_TYPE, SHTAKETNIK_OTHER_TYPE],
  withoutPanelModul: [PROFNASTIL_OTHER_TYPE, SHTAKETNIK_OTHER_TYPE, ZHALYUZI_OTHER_TYPE],
  withAll: [
    PROFNASTIL_OTHER_TYPE,
    SHTAKETNIK_OTHER_TYPE,
    MODULNYE_OGRAZHDENIYA_OTHER_TYPE,
    PANELNYE_OGRAZHDENIYA_OTHER_TYPE,
    ZHALYUZI_OTHER_TYPE,
  ],
};
